// API 配置
const API_CONFIG = {
  baseUrl: 'https://ring.shcj.xyz/api',
  imgUrl: 'https://ring.shcj.xyz',
  android: {
    appId: '__UNI__AA8744A',
    platform: 'Android',
    apiUrl: 'https://ring.shcj.xyz/api/api/v1/app/version/checkAppVersion'
  },
  ios: {
    appId: '__UNI__AA8744A',
    platform: 'iOS',
    apiUrl: 'https://ring.shcj.xyz/api/api/v1/app/version/checkAppVersion'
  }
}

// 通用的API请求函数
async function fetchAppData(platform) {
  const config = API_CONFIG[platform.toLowerCase()]
  
  if (!config) {
    console.error(`不支持的平台: ${platform}`)
    return null
  }
  
  try {
    const url = `${config.apiUrl}?appId=${config.appId}&platform=${config.platform}`
    console.log(`请求${platform} API:`, url)
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      }
    })
    
    if (!response.ok) {
      throw new Error(`HTTP错误! 状态: ${response.status}`)
    }
    
    const data = await response.json()
    
    if (data.code === 1 && data.status === true) {
      console.log(`${platform} API响应成功:`, data.data)
      return data.data
    } else {
      throw new Error(data.msg || `API返回错误: ${data.code}`)
    }
    
  } catch (error) {
    console.error(`获取${platform}应用数据失败:`, error)
    return null
  }
}

// Android 应用数据
export async function fetchAndroidData() {
  return await fetchAppData('Android')
}

// iOS 应用数据
export async function fetchIOSData() {
  return await fetchAppData('iOS')
}

export function fetchPrefix() {
  return API_CONFIG.imgUrl
}

// 备用数据
export const fallbackData = {
  appName: "Genius Ring",
  description: "我们的应用提供卓越的用户体验，简洁的界面设计和强大的功能。支持多平台同步，让您随时随地享受便捷服务。立即下载，开启全新数字生活！",
  updateTitle: "应用更新",
  updateContent: "修复一些已知BUG",
  version: "1.0.1",
  versionCode: 119,
  platform: "Android",
  downloadUrl: "",
  filePath: "",
  extension: "apk",
  forceUpdate: 0,
  silentUpdate: 0,
  uploadDate: "2026-01-19T11:15:10"
}